var map = {
	"./16x9_blur.jpg": "2201",
	"./16x9_border.jpg": "7e4f",
	"./16x9_center.jpg": "07c0",
	"./16x9_collage.jpg": "2648",
	"./16x9_repeat.jpg": "ec4c",
	"./1x1_blur.jpg": "4d5e",
	"./1x1_border.jpg": "a9de",
	"./1x1_center.jpg": "8dce",
	"./1x1_collage.jpg": "29a0",
	"./1x1_repeat.jpg": "d988",
	"./2x3_blur.jpg": "4b0b",
	"./2x3_border.jpg": "5cca",
	"./2x3_center.jpg": "004f",
	"./2x3_collage.jpg": "b6f5",
	"./2x3_repeat.jpg": "a6f5",
	"./9x16_blur.jpg": "a807",
	"./9x16_border.jpg": "e7ff",
	"./9x16_center.jpg": "669e",
	"./9x16_collage.jpg": "b889",
	"./9x16_repeat.jpg": "2f59",
	"./Logo_border.jpg": "8e00",
	"./Logo_corner_bottom_left.jpg": "384c",
	"./Logo_corner_bottom_right.jpg": "114b",
	"./Logo_corner_top_left.jpg": "b176",
	"./Logo_corner_top_right.jpg": "ab0c",
	"./Logo_full_bleed.jpg": "a67d",
	"./ii_toolkit-poster.jpg": "3568"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8af7";